
import { defineComponent, PropType } from "vue";
import { MediaModel } from "@/entities/Media";
import Card from "@/components/common/Card.vue";

export default defineComponent({
  components: { Card },
  props: {
    media: {
      type: Object as PropType<MediaModel>,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
